import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { apiHandler } from '../../api/apihandler';
import { CHALLENGE_PERTICIPANTS_COMMENT } from "../../api/constants";
import SingleUserParticipateComment from './singleUserParticipateComment'


const ParticipateCommentList = ({ participateId, refreshPCList, setRefreshPCList }) => {
    const [commentList, setCommentList] = useState([]);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
        getCommentList(1)
    }, [])

    useEffect(() => {
        getCommentList(1)
        setRefreshPCList(false)
    }, [refreshPCList])


    // limit:100 with no pagination silently hid every comment past the first
    // 100 on a busy thread - page through with "Load more" instead.
    async function getCommentList(pageVal = 1) {
        setLoadingMore(true)
        try {
            const res = await apiHandler(CHALLENGE_PERTICIPANTS_COMMENT, "POST", {
                page: pageVal,
                limit: 100,
                participate_id: participateId
            })
            if (res.data?.response?.status === 200) {
                setMaxPage(res?.data?.data?.comments?.meta?.last_page || 1)
                setPage(pageVal)
                if (pageVal === 1) {
                    setCommentList(res?.data?.data?.comments?.data || [])
                } else {
                    setCommentList(prev => [...prev, ...(res?.data?.data?.comments?.data || [])])
                }
            } else {
                //navigate('/auth/sign-in')
                //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
                //console.log("profileRes",res)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoadingMore(false)
        }
    }

    return (
        <>
            <div className="comment-area mt-3" style={{ marginTop: "10px" }}>
                {/* <h5 style={{ marginTop: "5px" }}>List of Comments</h5> */}
                {
                    commentList?.map((elm, i) => (
                        <div key={elm?.id}>
                            <SingleUserParticipateComment participateId={participateId} commentElm={elm} setRefreshPCList={setRefreshPCList} />
                            {
                                elm?.replies?.map((innerElm, index) => (
                                    <div style={{ marginLeft: "40px" }}>
                                        <SingleUserParticipateComment participateId={participateId} commentElm={innerElm} setRefreshPCList={setRefreshPCList} />
                                        {
                                            innerElm?.replies?.map((innerElm2, index) => (
                                                <div style={{ marginLeft: "40px" }}>
                                                    <SingleUserParticipateComment participateId={participateId} commentElm={innerElm2} setRefreshPCList={setRefreshPCList} />
                                                    {
                                                        innerElm2?.replies?.map((innerElm3, index) => (
                                                            <div style={{ marginLeft: "40px" }}>
                                                                <SingleUserParticipateComment participateId={participateId} commentElm={innerElm3} setRefreshPCList={setRefreshPCList} />
                                                                {
                                                                    innerElm3?.replies?.map((innerElm4, index) => (
                                                                        <div style={{ marginLeft: "40px" }}>
                                                                            <SingleUserParticipateComment participateId={participateId} commentElm={innerElm4} setRefreshPCList={setRefreshPCList} />
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
                {
                    page < maxPage ?
                        <div className="text-center mt-2">
                            <Button variant="primary" size="sm" disabled={loadingMore}
                                onClick={() => getCommentList(page + 1)}>
                                {loadingMore ? 'Loading...' : 'Load more'}
                            </Button>
                        </div> : null
                }
                {/* <CommentBox postId={postId} commentId={""} /> */}
            </div>
        </>
    )
}

export default ParticipateCommentList
